import React from 'react';
import NotFound from './containers/NotFound';
import ProductDetailPage from './containers/ProductDetailPage';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

const Routes = () => (
  <Router>
    <Switch>
      <Redirect path='/' to='/mas' exact />
      <Route path='/mas/:id' exact component={ProductDetailPage} />
      {/* Finally, catch all unmatched routes */}
      <Route component={NotFound} />
    </Switch>
  </Router>
);

export default Routes;
